export const UPLOAD_URL_TTL = 7 * 24 * 60 * 60 * 1000;
